/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import IntegrationscontentfulContentfulIntegration from './IntegrationscontentfulContentfulIntegration';

/**
 * The IntegrationsContentfulBody model module.
 * @module model/IntegrationsContentfulBody
 * @version v0.3
 */
export default class IntegrationsContentfulBody {
  /**
   * Constructs a new <code>IntegrationsContentfulBody</code>.
   * @alias module:model/IntegrationsContentfulBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>IntegrationsContentfulBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IntegrationsContentfulBody} obj Optional instance to populate.
   * @return {module:model/IntegrationsContentfulBody} The populated <code>IntegrationsContentfulBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new IntegrationsContentfulBody();
      if (data.hasOwnProperty('contentful_integration'))
        obj.contentfulIntegration = IntegrationscontentfulContentfulIntegration.constructFromObject(data['contentful_integration']);
    }
    return obj;
  }
}

/**
 * @member {module:model/IntegrationscontentfulContentfulIntegration} contentfulIntegration
 */
IntegrationsContentfulBody.prototype.contentfulIntegration = undefined;

